import { Navigate, useLocation } from 'react-router-dom';
import { useUserRoles } from '@/hooks/useUserRoles';

const PUBLIC_PREFIXES = ['/login', '/register', '/auth', '/pricing', '/enterprise', '/reviewer'];

export default function RoleRedirect() {
  const location = useLocation();
  const { isReviewerOnly, loading } = useUserRoles();

  if (loading) return null;
  if (!isReviewerOnly) return null;
  if (PUBLIC_PREFIXES.some((p) => location.pathname === p || location.pathname.startsWith(`${p}/`))) {
    return null;
  }
  if (location.pathname === '/') return null;

  return <Navigate to="/reviewer" replace />;
}
